import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { DailySoluition } from '@/domain/entities/dashboard/dailySolution'
import { LanguageStatistics } from '@/domain/entities/problem/languageStatistics'
import { StatisticsModuleName } from '@/store/modules/modules'

export class StatisticsViewModel {
  private store = useStore()

  userLanguageStatisticsList: ComputedRef<LanguageStatistics[]> = computed(
    () => this.store.getters[`${StatisticsModuleName}/userLanguageStatisticsList`]
  )
  userDailySolutionList: ComputedRef<DailySoluition[][]> = computed(
    () => this.store.getters[`${StatisticsModuleName}/userDailySolutionList`]
  )
  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${StatisticsModuleName}/isLoading`])
  error: ComputedRef<string | null> = computed(() => this.store.getters[`${StatisticsModuleName}/error`])

  async addUserStatistics(userId: string): Promise<void> {
    await this.store.dispatch(`${StatisticsModuleName}/addUserStatistics`, { userId: userId })
  }

  removeUserStatistics(): void {
    this.store.commit(`${StatisticsModuleName}/removeUserStatistics`)
  }

  removeTargetUsers(): void {
    this.store.commit(`${StatisticsModuleName}/removeTargetUsers`)
  }
}
